/* src/app/app.component.scss */
amplify-authenticator {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100vh;
  --amplify-primary-color: var(--findcare-button);
  background-color: #fff;
  font-family: "MuseoSansRegular";
}
ion-app {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: auto !important;
  margin-top: env(safe-area-inset-top) !important;
  background: #fff;
}
.alertmsg-button {
  background: red;
  padding: 5px 20px;
  color: #fff;
  margin-bottom: 10px;
}
.menu-head {
  display: flex;
  align-items: center;
  color: #000;
  font-size: 1.7rem;
}
.menu-head div {
  margin: 0 auto;
}
.menu-head ion-button {
  margin: 0;
  font-size: 1.2rem;
}
.menu-head ion-icon {
  color: var(--color-tabactive);
}
.menu-list ion-item {
  font-size: 1rem;
  cursor: pointer;
}
.highlights {
  color: var(--color-tabactive);
  font-weight: 500;
}
.menu-head {
  background: var(--header-background);
  text-align: center;
  padding: 10px;
  border-right: 1px solid #fff;
}
.menu-head img {
  width: 100px;
  cursor: pointer;
}
.menu-div {
  text-align: center;
  border-bottom: 1px solid var(--border);
}
.menu-btn ion-button {
  font-family: var(--subheader-font);
  font-size: 1.25rem;
  color: var(--button);
  letter-spacing: 0;
}
/*# sourceMappingURL=app.component.css.map */
